import { getInternationalTeam } from '../../actions/ApiCalls';
import { useEffect, useState } from "react";
import './InternationalTeam.css';
import { IMAGE_URL } from "../../path";

function InternationalTeam() {
    const [team, setTeam] = useState<any[]>([]);

    useEffect(() => {
        fetchTeam();
    }, []);

    function fetchTeam() {
        getInternationalTeam()
            .then(response => {
                setTeam(response.data.data);
            })
            .catch(error => console.error("Failed to fetch team:", error));
    }

    return (
        <div className="team-container">

            <div className="team-grid">
                {team.map((member, index) => (
                    <div key={index} className="team-card">
                        <div className="img-wrapper">
                            <img
                                src={`${IMAGE_URL}${member.image_path}`}
                                alt={member.name}
                                className="team-img"
                            />
                        </div>
                        <p className="team-name">{member.name}</p>
                        <p className="team-title">{member.title}</p>

                        <p className="team-email">
                            <a target="_blank"
                               rel="noopener noreferrer" href={`mailto:${member.email_address}`}>{member.email_address}</a>
                        </p>
                        <p className="team-region">{member.regions}</p>
                    </div>

                ))}
            </div>

        </div>
    );
}

export default InternationalTeam;
